import { render } from "./ExportFobsView.vue?vue&type=template&id=057613aa&scoped=true"
import script from "./ExportFobsView.vue?vue&type=script&lang=js"
export * from "./ExportFobsView.vue?vue&type=script&lang=js"

import "./ExportFobsView.vue?vue&type=style&index=0&id=057613aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057613aa"]])

export default __exports__